module.exports = __webpack_public_path__ + "static/media/list-menu-arrow.592cfb99.svg";